import DropdownFilter, { IDropdownFilterProps } from './DropdownFilter'
import { Optional } from 'utility-types'

type BooleanFilterProps = Optional<IDropdownFilterProps, 'options'>

const BooleanFilter = (props: BooleanFilterProps) => {
  const options = [
    {
      text: 'True',
      value: 'true'
    },
    {
      text: 'False',
      value: 'false'
    }
  ]

  return <DropdownFilter options={options} {...props} />
}

export default BooleanFilter
